import moment from 'moment'

import { portalApi } from '@/axios'
import { Statistic } from '@/classes/models'

import DateRangeCalculator from '@/classes/helpers/DateRangeCalculator'

const dateRangeCalculator = new DateRangeCalculator(moment)

export default class StatisticsService {
  /**
   * Get empty Statistic as placeholder.
   *
   * @param {object} intervalRange
   *
   * @return {Promise}
   */
  static getEmpty (intervalRange) {
    const { startDate, endDate, range } = this.getIntervalRange(intervalRange)

    return Promise.resolve(new Statistic({ startDate, endDate, datapoints: [...range] }))
  }

  /**
   * Get a statistic dashboard set for a merchant.
   *
   * @param {Context} context
   * @param {object} intervalRange
   * @param {object} parameters
   *
   * @return {Promise}
   */
  static getDashboard (context, intervalRange, parameters) {
    const { startDate, endDate, range } = this.getIntervalRange(intervalRange)

    let request = portalApi.post(`${this.endpoint(context)}/dashboard`, {
      ...parameters,
      'dateRange': range
    }).then(response => {
      return response.data
    })

    // Map to Statistic
    return request.then(response => {
      return new Statistic({ ...response, startDate, endDate })
    }).catch(error => {
      return Promise.reject(error)
    })
  }

  /**
   * Get a statistic declines set for a merchant.
   *
   * @param {Context} context
   * @param {object} context
   *
   * @return {Promise}
   */
  static getDeclines (context, parameters) {
    const { startDate, endDate } = parameters

    let request = portalApi.post(`${this.endpoint(context)}/dashboard/declines`, {
      'currency': parameters.currency,
      'dateRange': [{ startDate, endDate }]
    }).then(response => {
      return response.data
    })

    // Map to Statistic
    return request.then(response => {
      return new Statistic({ ...response, startDate, endDate })
    }).catch(error => {
      return Promise.reject(error)
    })
  }

  /**
   * Endpoint of API.
   *
   * @param {Context} context
   *
   * @return {string}
   */
  static endpoint (context) {
    return `${context.endpoint(['business', 'merchant'])}`
  }

  static getIntervalRange ({ interval, startDate, endDate }) {
    const intervals = {
      'hour': (startDate) => dateRangeCalculator.getHourRange(startDate),
      'day': (startDate, endDate) => dateRangeCalculator.getDayRange(startDate, endDate),
      'week': (startDate, endDate) => dateRangeCalculator.getWeekRange(startDate, endDate),
      'month': (startDate, endDate) => dateRangeCalculator.getMonthRange(startDate, endDate),
      'year': (startDate, endDate) => dateRangeCalculator.getYearRange(startDate, endDate)
    }

    return intervals[interval](startDate, endDate)
  }
}
